// eslint-disable-next-line no-redeclare
const Citiesocial = {
  config: {
    userIdCookieName: 'd41d8cd98f00b204e9800998ecf8427e',
  },
  version: '18.5.11',
  getUserId: function () {
    return Citiesocial.utils.getCookie(Citiesocial.config.userIdCookieName);
  },
  setUserId: function (customerId) {
    Citiesocial.utils.setCookie(
      Citiesocial.config.userIdCookieName,
      customerId,
      180,
    );
  },
  identifyUser: async function (customer) {
    const userData = JSON.stringify({
      shopify_customer_id: customer.id,
      email: customer.email,
    });
    $.ajax({
      type: 'POST',
      url: `${PY3_API_BASE_URL}/api/v1.2/shopify-domain/customers/get-account/`,
      headers: {
        Authorization:
          'Basic ' +
          btoa(
            'citiesocial_native_mobile_app' +
              ':' +
              'PW9Xk9p6vQ2v9Q3H8be3nVYMGzqDhUDk',
          ),
      },
      dataType: 'json',
      contentType: 'application/json',
      data: userData,
      success: function (response) {
        window.analytics.identify(response.results.id, {
          email: response.results.email,
          total_order: customer.ordersCount,
          total_spent: customer.totalSpent,
        });
        sessionStorage.setItem('cs_userId', response.results.id);
        return response.results.id;
      },
      error: function (xhr) {
        console.log('error: ' + xhr);
      },
    });
  },
  getDeviceType: function () {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet';
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua,
      )
    ) {
      return 'mobile';
    }
    return 'desktop';
  },
  getOS: function () {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }
    return os;
  },
  utils: {
    testGroup00CookieName: '__cs_tg00',
    setCookie: function (name, value, days) {
      Cookies.set(name, value, { expires: days });
    },
    getCookie: function (name) {
      if (document.cookie.length > 0) {
        return Cookies.get(name);
      }
      return '';
    },
    removeCookie: function (name = '') {
      Cookies.remove(name);
    },
    getTestGroup00: function () {
      var currentTestGroup00 = Cookies.get(this.testGroup00CookieName);
      if (currentTestGroup00 === '' || currentTestGroup00 == null) {
        // get random integer between 1 and 6 inclusive
        currentTestGroup00 = Math.floor(Math.random() * 6) + 1;
        this.setCookie(this.testGroup00CookieName, currentTestGroup00, 1000);
      }
      return currentTestGroup00.toString();
    },
    generateFormBody: function (data) {
      const formBody = [];
      for (const key in data) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(data[key]);
        formBody.push(`${encodedKey}=${encodedValue}`);
      }
      return formBody.join('&');
    },
    shuffle: function (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    throttle: function (func, duration) {
      let shouldWait = false;
      return function (...args) {
        if (!shouldWait) {
          func.apply(this, args);
          shouldWait = true;
          setTimeout(function () {
            shouldWait = false;
          }, duration);
        }
      };
    },
    debounce: function (func, wait, options) {
      let timeout;
      let immediate;
      let callFirst;
      if (Citiesocial.utils.isObject(options)) {
        ({ immediate = false, callFirst = false } = options);
      }
      return function () {
        const context = this;
        const args = arguments;
        if (callFirst) {
          callFirst = false;
          func.apply(context, args);
        }

        const later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    },
    isSafari: function () {
      let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      // 排除 Chrome、Firefox APP
      if (
        navigator.userAgent.match('CriOS') ||
        navigator.userAgent.match('FxiOS')
      ) {
        isSafari = false;
      }
      return isSafari;
    },
    isObject: function (variable) {
      return Object.prototype.toString.call(variable) === '[object Object]';
    },
    isApp: function () {
      return navigator.userAgent.includes('cs_webview');
    },
    isWebview: function () {
      const { userAgent } = navigator;
      const rules = [
        'WebView',
        '(iPhone|iPod|iPad)(?!.*Safari/)',
        'Android.*(wv|.0.0.0)',
      ];
      const regex = new RegExp(`(${rules.join('|')})`, 'ig');
      return Boolean(userAgent.match(regex));
    },
    isMobile: function () {
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        ) && !window.MSStream
      );
    },
    detectInAppBrowser: function () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const BROWSER = {
        Messenger: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
        Facebook: /\bFB[\w_]+\//,
        Twitter: /\bTwitter/i,
        LINE: /\bLine\//i,
        Wechat: /\bMicroMessenger\//i,
        Puffin: /\bPuffin/i,
        miui: /\bMiuiBrowser\//i,
        Instagram: /\bInstagram/i,
        Chrome: /\bCrMo\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?/,
        Safari: /Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari/,
        ie: /IEMobile|MSIEMobile/,
        Firefox: /fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS/,
        Opera: /Opera|OPR\//,
        Edge: /Edge|Edg\//,
        Vivaldi: /Vivaldi/,
        Brave: /Brave\//,
        DuckDuckGo: /DuckDuckGo/,
        SamsungBrowser: /SamsungBrowser/,
        UC: /UCBrowser/,
      };
      for (const browser in BROWSER) {
        const pattern = BROWSER[browser];
        if (pattern.test(userAgent)) {
          return browser;
        }
      }
      return 'unknown';
    },
    countdown: function (time) {
      const countDownDate = new Date(time).getTime();
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance <= 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        return { days, hours, minutes, seconds };
      }
    },
    getCountdownLabelText: function (countdown) {
      const { days, hours, minutes, seconds } = countdown;
      if (days % COUNTDOWN_MOD) {
        return `倒數 ${days % COUNTDOWN_MOD} 天`;
      } else if (hours) {
        return `倒數 ${hours} 小時`;
      } else if (minutes) {
        return `倒數 ${minutes} 分鐘`;
      } else if (seconds) {
        return `倒數 ${seconds} 秒`;
      } else {
        return '';
      }
    },
    formatNumber: function (data) {
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getSelectedVariant: function (variants) {
      const length = variants.length;
      if (length === 1) {
        return variants[0];
      }
      // 找商品中第一個有庫存的 variant
      const firstIndexWithInventory = variants.findIndex(
        (variant) => variant.inventory_quantity > 0,
      );
      return firstIndexWithInventory >= 0
        ? variants[firstIndexWithInventory]
        : variants[0];
    },
    detectMobilOS: function () {
      if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
        return 'ios';
      } else if (/Android/i.test(window.navigator.userAgent)) {
        return 'android';
      } else {
        return '';
      }
    },
    hasClassName: function (element, className) {
      return element.classList.contains(className);
    },
    toggleClassName: function (element, className) {
      element.classList.toggle(className);
    },
    asyncLoad: function (link) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = link;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    },
    waitForGoogleAnalyticsLoadedToExecute: function (func) {
      if (typeof func !== 'function') {
        return;
      }

      if (typeof ga === 'function') {
        func();
      } else {
        setTimeout(() => {
          Citiesocial.utils.waitForGoogleAnalyticsLoadedToExecute(func);
        }, 500);
      }
    },
    getUrlVars: function () {
      var vars = [],
        hash;
      var hashes = window.location.href
        .slice(window.location.href.indexOf('?') + 1)
        .split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    parseJwt: function (token) {
      if (!token) {
        return {};
      }

      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(''),
      );

      return JSON.parse(jsonPayload);
    },
    getCurrency: function (number) {
      return `NT$ ${Number(number).toLocaleString('zh-TW')}`;
    },
    uuidv4: function () {
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (
          +c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
        ).toString(16),
      );
    },
    getReferrerPath: function () {
      const referrer = document.referrer;
      try {
        if (referrer) {
          return new URL(referrer).pathname;
        }
      } catch (error) {
        console.error('Error parsing referrer URL:', error);
      }
      return '';
    },
    convertPhoneNumber: function (phoneNumber) {
      // 檢查手機號碼是否以 '0' 開頭，並且長度為 10 位數
      if (/^0[0-9]{9}$/.test(phoneNumber)) {
        // 使用 replace 方法將開頭的 '0' 替換成 '+886'
        return phoneNumber.replace(/^0/, '+886');
      }

      return phoneNumber;
    },
    safeJsonParse: function (jsonString, defaultValue = null) {
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        return defaultValue;
      }
    },
    safeJsonStringify: function (
      value,
      defaultValue = '{}',
      replacer = null,
      space = null,
    ) {
      try {
        return JSON.stringify(value, replacer, space);
      } catch (error) {
        console.error('JSON.stringify failed:', error);
        return defaultValue;
      }
    },
    oldSchoolCopy: function (text) {
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = text;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
    },
  },
  userManager: {
    isLogin: function () {
      return window.customer !== undefined;
    },
    getLoginStatus: function () {
      if (Citiesocial.userManager.isLogin()) {
        return 'Full';
      } else if (Citiesocial.authManager.getAccessToken()) {
        return 'Semi';
      } else {
        return 'None';
      }
    },
    getCustomer: function () {
      return window.customer;
    },
    fetchUserFavoriteProducts: async function (size = 12, page = 1) {
      if (!Citiesocial.authManager.getAccessToken()) {
        return [[], {}];
      }
      try {
        const response = await fetch(
          `${PY3_API_BASE_URL}/api/v1.2/product/favorites/?page=${page}&page_size=${size}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': APPLICATION_JSON,
              Authorization: Citiesocial.authManager.getAuthorizationHeader(),
            },
          },
        );
        const responseJson = await response.json();
        const { favorites, page_info: pageInfo } = responseJson.results;
        const userFavoriteProducts = favorites.map(({ product }) => {
          return Citiesocial.productManager.favoriteProductsFormat(product);
        });
        return { userFavoriteProducts, pageInfo };
      } catch (error) {
        return [[], {}];
      }
    },
    fetchUserFavoriteProductIds: async function () {
      try {
        const response = await fetch(
          `${PY3_API_BASE_URL}/api/v1.2/product/favorites/?page_size=200&source=browser`,
          {
            method: 'GET',
            headers: {
              'Content-Type': APPLICATION_JSON,
              Authorization: Citiesocial.authManager.getAuthorizationHeader(),
            },
          },
        );
        const responseJson = await response.json();
        return responseJson.results.favorites.map(
          (favorite) => favorite.product.shopify_id,
        );
      } catch (error) {
        return [];
      }
    },
    addProductsToFavorites: async function (productIds = []) {
      if (productIds.length === 0) {
        return;
      }
      const data = {
        shopify_product_ids: productIds,
        product_ids: [],
        source: 'browser',
      };
      fetch(`${PY3_API_BASE_URL}/api/v1.2/product/favorites/`, {
        method: 'POST',
        headers: {
          'Content-Type': APPLICATION_JSON,
          Authorization: Citiesocial.authManager.getAuthorizationHeader(),
        },
        body: JSON.stringify(data),
      });
    },
    removeProductsFromFavorites: function (productIds = []) {
      if (productIds.length === 0) {
        return;
      }
      const data = {
        shopify_product_ids: productIds,
        product_ids: [],
        source: 'browser',
      };
      fetch(`${PY3_API_BASE_URL}/api/v1.2/product/favorites/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': APPLICATION_JSON,
          Authorization: Citiesocial.authManager.getAuthorizationHeader(),
        },
        body: JSON.stringify(data),
      });
    },
    getUserFavoriteProductIdSet: function () {
      const userFavoriteProductIds =
        JSON.parse(localStorage.getItem('userFavoriteProductIds')) || [];
      return new Set(userFavoriteProductIds);
    },
    setUserFavoriteProductIds(productIds = []) {
      localStorage.setItem(
        'userFavoriteProductIds',
        JSON.stringify(productIds),
      );
    },
    handleLoginAndRegisterRedirect() {
      $('#checkout__login, #checkout__register').click(function () {
        sessionStorage.setItem('targetRedirectPath', window.location.pathname);
      });
    },
    showGoogleLoginAlertModal() {
      const googleLoginAlertModal = $(
        '[data-remodal-id=modal-google-login-alert]',
      ).remodal();
      const inAppBrowser = Citiesocial.utils.detectInAppBrowser();
      const displayBrowserName = [
        'Chrome',
        'Safari',
        'ie',
        'Firefox',
        'unknown',
      ].includes(inAppBrowser)
        ? 'APP 應用程式'
        : inAppBrowser;
      $('#modal-google-login-alert__in-app-browser').text(
        ` ${displayBrowserName} 的`,
      );
      googleLoginAlertModal.open();
    },
    getSegmentAnonymousId() {
      try {
        return window?.analytics?.user()?.anonymousId();
      } catch (error) {
        // 如果 Segment 未初始化，則從 localStorage 中獲取
        return (
          Citiesocial.utils.safeJsonParse(
            localStorage.getItem('ajs_anonymous_id'),
          ) || undefined
        );
      }
    },
    getLineMember: async function ({ clid }) {
      try {
        if (!clid) {
          return null;
        }
        const response = await fetch(
          `${PY3_API_BASE_URL}/api/v1.2/cresclab/member/?clid=${clid}`,
        );
        const responseJson = await response.json();
        return responseJson.results;
      } catch (error) {
        return null;
      }
    },
    mapLineMemberToCustomer: async function ({ customer_id, line_uid }) {
      try {
        const response = await fetch(
          `${PY3_API_BASE_URL}/api/v1.2/cresclab/member/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': APPLICATION_JSON,
              Authorization: Citiesocial.authManager.getAuthorizationHeader(),
            },
            body: JSON.stringify({ customer_id, line_uid }),
          },
        );
        const responseJson = await response.json();
        return responseJson.results;
      } catch (error) {
        return null;
      }
    },
    trackAccountSuccess: async function () {
      const accountButtonClicked = sessionStorage.getItem(
        'account_button_clicked',
      );
      if (accountButtonClicked && Citiesocial.userManager.isLogin()) {
        $('body').trigger('customer:account:success');
        await new Promise((resolve) => setTimeout(resolve, 3000));
        window.segmentTracking.accountSuccess(accountButtonClicked);
      }
    },
  },
  testManager: {
    getRandomGroup({ uuidKey, modValue, groupMap }) {
      let uuid = localStorage.getItem(uuidKey);
      if (!uuid) {
        uuid = Citiesocial.utils.uuidv4();
        localStorage.setItem(uuidKey, uuid);
      }
      const decimalUuid = parseInt(uuid.slice(0, 3), 16);
      const group = groupMap[decimalUuid % modValue];
      return group;
    },
    getABTestGroup() {
      if (searchParams.get('ab_test_group')) {
        const testGroup = searchParams.get('ab_test_group');
        if (['A', 'B'].includes(testGroup)) {
          return testGroup;
        }
      }
      return Citiesocial.testManager.getRandomGroup({
        uuidKey: 'cs_cart_test_uuid',
        modValue: 2,
        groupMap: { 0: 'A', 1: 'B' },
      });
    },
    getCartAddOnABTestGroup() {
      return Citiesocial.testManager.getRandomGroup({
        uuidKey: 'cs_cart_add_on_test_uuid',
        modValue: 2,
        groupMap: { 0: 'A', 1: 'B' },
      });
    },
    getABTestGroupA3B7() {
      return Citiesocial.testManager.getRandomGroup({
        uuidKey: 'ab_test_group_a3_b7_uuid',
        modValue: 10,
        groupMap: {
          0: 'A',
          1: 'A',
          2: 'A',
          3: 'B',
          4: 'B',
          5: 'B',
          6: 'B',
          7: 'B',
          8: 'B',
          9: 'B',
        },
      });
    },
    getABCTestGroup() {
      return Citiesocial.testManager.getRandomGroup({
        uuidKey: 'abc_test_group_uuid',
        modValue: 3,
        groupMap: {
          0: 'A',
          1: 'B',
          2: 'C',
        },
      });
    },
    getABCDTestGroup() {
      if (searchParams.get('abcd_test_group')) {
        const testGroup = searchParams.get('abcd_test_group');
        if (['A', 'B', 'C', 'D'].includes(testGroup)) {
          return testGroup;
        }
      }
      return Citiesocial.testManager.getRandomGroup({
        uuidKey: 'abcd_test_group_uuid',
        modValue: 4,
        groupMap: {
          0: 'A',
          1: 'B',
          2: 'C',
          3: 'D',
        },
      });
    },
  },
  authManager: {
    socialLogin: async function (provider) {
      const segmentAnonymousId = Citiesocial.userManager.getSegmentAnonymousId();
      const authBaseURL = `${PY3_API_BASE_URL}/cs/api/v2/auth/oauth/`;
      const targetURL = new URL(`${authBaseURL}${provider}/`);
      const welfareCommittee = localStorage.getItem('welfare-committee');

      if (welfareCommittee) {
        targetURL.searchParams.append('welfare_committee', welfareCommittee);
      }

      targetURL.searchParams.append(
        'redirect_uri',
        window.location.origin + '/pages/social-login-redirect',
      );

      if (segmentAnonymousId) {
        targetURL.searchParams.append('anonymous_id', segmentAnonymousId);
      }

      window.location.href = targetURL.href;
    },
    fetchToken: async function ({ code, redirect_uri }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/auth/token/`,
        {
          method: 'POST',
          body: JSON.stringify({
            grant_type: 'authorization_code',
            redirect_uri,
            code,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const { results } = await response.json();
      const {
        id_token,
        access_token,
        refresh_token,
        multipass_token,
      } = results;

      localStorage.setItem('cs_id_token', id_token);
      localStorage.setItem('cs_access_token', access_token);
      localStorage.setItem('cs_refresh_token', refresh_token);
      Citiesocial.utils.setCookie('cs_token_flag', '1', 1000);

      await Citiesocial.authManager.fetchShopifyCustomerAccessToken({
        multipassToken: multipass_token,
      });

      return {
        idToken: id_token,
        accessToken: access_token,
        refreshToken: refresh_token,
        multiPassToken: multipass_token,
      };
    },
    refreshToken: async function ({ redirectUri }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/auth/token/`,
        {
          method: 'POST',
          body: JSON.stringify({
            grant_type: 'refresh_token',
            refresh_token: localStorage.getItem('cs_refresh_token'),
            redirect_uri: redirectUri,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const data = await response.json();

      if (data.error || data?.results?.multipass_token === undefined) {
        await Citiesocial.authManager.logout();
        Citiesocial.authManager.clearToken();
        window.segmentTracking?.refreshTokenFailed({
          error: data?.error,
          results: data?.results,
          multipass_token: data?.results?.multipass_token,
          data_response: JSON.stringify(data),
        });
        window.location.reload();
        return {};
      }

      const {
        id_token,
        access_token,
        refresh_token,
        multipass_token,
      } = data.results;

      localStorage.setItem('cs_id_token', id_token);
      localStorage.setItem('cs_access_token', access_token);
      localStorage.setItem('cs_refresh_token', refresh_token);

      await Citiesocial.authManager.fetchShopifyCustomerAccessToken({
        multipassToken: multipass_token,
      });

      return {
        idToken: id_token,
        accessToken: access_token,
        refreshToken: refresh_token,
        multiPassToken: multipass_token,
      };
    },
    fetchShopifyCustomerAccessToken: async function ({ multipassToken }) {
      const shopifyStorefrontApiClient = Citiesocial.storefrontApiManager.getClient();
      const { data } = await shopifyStorefrontApiClient.request(
        Citiesocial.storefrontApiManager.mutation
          .customerAccessTokenCreateWithMultipass,
        {
          variables: {
            multipassToken,
          },
        },
      );
      const shopifyCustomerAccessToken =
        data?.customerAccessTokenCreateWithMultipass?.customerAccessToken
          ?.accessToken;
      if (shopifyCustomerAccessToken) {
        localStorage.setItem(
          'shopifyCustomerAccessToken',
          shopifyCustomerAccessToken,
        );
      }
    },
    getAuthorizationHeader: function () {
      if (IS_OPEN_NEW_LOGIN_REGISTER) {
        if (!localStorage.getItem('cs_access_token')) {
          return undefined;
        }
        return `Bearer ${localStorage.getItem('cs_access_token')}`;
      } else {
        return Citiesocial.utils.getCookie('cs_token');
      }
    },
    getAccessToken: function () {
      if (IS_OPEN_NEW_LOGIN_REGISTER) {
        return localStorage.getItem('cs_id_token') &&
          localStorage.getItem('cs_access_token')
          ? localStorage.getItem('cs_access_token')
          : undefined;
      } else {
        return Citiesocial.utils.getCookie('cs_token');
      }
    },
    getIdToken: function () {
      if (IS_OPEN_NEW_LOGIN_REGISTER) {
        return localStorage.getItem('cs_id_token');
      } else {
        return Citiesocial.utils.getCookie('cs_token');
      }
    },
    login: async function ({ email, password }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/auth/login/pwd/email/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            password,
          }),
        },
      );

      return response.json();
    },
    register: async function ({
      email,
      password,
      phone_number,
      last_name,
      first_name,
      gender,
      birthday,
    }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/account/register/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            password,
            phone_number,
            last_name,
            first_name,
            gender,
            birthday,
          }),
        },
      );
      return response.json();
    },
    logout: async function () {
      return fetch('/account/logout');
    },
    clearToken: function () {
      Citiesocial.utils.removeCookie('cs_token');
      Citiesocial.utils.removeCookie('cs_token_flag');
      // CS-CART DELETE
      // Citiesocial.utils.removeCookie('cart');
      window.localStorage.removeItem('cs_token');

      localStorage.removeItem('cs_id_token');
      localStorage.removeItem('cs_access_token');
      localStorage.removeItem('cs_refresh_token');
      localStorage.removeItem('shopifyCustomerAccessToken');
    },
    sendVerificationCode: async function ({
      type = 'phone',
      phoneNumber,
      email,
    }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/account/otp/${type}/send-code/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: Citiesocial.authManager.getAuthorizationHeader(),
          },
          body: JSON.stringify({
            phone_number: Citiesocial.utils.convertPhoneNumber(phoneNumber),
            email,
          }),
        },
      );
      return response.json();
    },
    verifyCode: async function ({ type = 'phone', phoneNumber, email, otp }) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/cs/api/v2/account/otp/${type}/verify-code/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: Citiesocial.authManager.getAuthorizationHeader(),
          },
          body: JSON.stringify({
            otp,
            phone_number: Citiesocial.utils.convertPhoneNumber(phoneNumber),
            email,
          }),
        },
      );
      return response.json();
    },
    verifyToken: async function () {
      try {
        const response = await fetch(
          `${PY3_API_BASE_URL}/cs/api/v2/auth/token/verify/`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: Citiesocial.authManager.getAuthorizationHeader(),
            },
          },
        );
        return response.json();
      } catch (error) {
        return { error };
      }
    },
  },
  favoriteManager: {
    start: function () {
      if (Citiesocial.utils.isApp()) return;

      this.activeHeartWhenProductIsUserFavorite();
      window.addEventListener(
        'userFavoriteProductIdsUpdate',
        this.activeHeartWhenProductIsUserFavorite,
      );
      this.initHeartElementsListener();
    },
    activeHeartWhenProductIsUserFavorite: function () {
      const userFavoriteProductIdSet = Citiesocial.userManager.getUserFavoriteProductIdSet();
      const heartElements = document.querySelectorAll('.favorite__heart');

      heartElements.forEach((heart) => {
        const productId = JSON.parse(heart.dataset.productId);

        const isUserFavorite = userFavoriteProductIdSet.has(productId);
        if (isUserFavorite) {
          heart.classList.add('active');
          const favoriteTextElement = heart.querySelector(
            '.favorite__heart__content',
          );
          if (favoriteTextElement) {
            favoriteTextElement.textContent = '取消收藏';
            favoriteTextElement.style.color = 'gray';
          }
        }
        heart.classList.add('show-favorite');
      });
    },
    initHeartElementsListener: function () {
      const heartElements = document.querySelectorAll('.favorite__heart');
      const targetElements = [...Array.from(heartElements)];

      const favoriteTextElement = document.querySelector(
        '.product__share .favorite__text',
      );
      if (IS_PRODUCT_PAGES && favoriteTextElement) {
        targetElements.push(favoriteTextElement);
      }

      targetElements.forEach((element) => {
        element.addEventListener(
          'click',
          Citiesocial.favoriteManager.handleProductFavoriteToggle,
        );
      });
    },
    handleProductFavoriteToggle: function (event) {
      const isInProductCard =
        Citiesocial.utils.hasClassName(
          this.parentNode,
          'product-card__image',
        ) ||
        Citiesocial.utils.hasClassName(
          this.parentNode,
          'cs-productItem-imageWrapper',
        );
      if (isInProductCard) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (
        !Citiesocial.userManager.isLogin() &&
        !Citiesocial.authManager.getAccessToken()
      ) {
        // fix：Add save window.location.search to prevent popular-keyword not display.
        sessionStorage.setItem(
          'targetRedirectPath',
          window.location.pathname + window.location.search,
        );
        sessionStorage.setItem('favoriteProductID', this.dataset.productId);
        window.location.href = '/account/login';
        return;
      }

      let targetHeartElement = this;
      const isFavoriteTextElement = Citiesocial.utils.hasClassName(
        this,
        'favorite__text',
      );
      if (isFavoriteTextElement) {
        targetHeartElement = this.parentNode.querySelector('.favorite__heart');
      }

      const isHeartActive = Citiesocial.utils.hasClassName(
        targetHeartElement,
        'active',
      );
      const productId = JSON.parse(targetHeartElement.dataset.productId);
      const productTitle = targetHeartElement.dataset.productTitle;
      const currentUserFavoriteProductIdSet = Citiesocial.userManager.getUserFavoriteProductIdSet();

      if (isHeartActive) {
        Citiesocial.userManager.removeProductsFromFavorites([
          productId.toString(),
        ]);
        currentUserFavoriteProductIdSet.delete(productId);
        window.segmentTracking.productRemovedFromWishlist({
          product_id: productId,
          title: productTitle,
        });
      } else {
        Citiesocial.userManager.addProductsToFavorites([productId.toString()]);
        currentUserFavoriteProductIdSet.add(productId);
        window.segmentTracking.productAddedToWishlist({
          product_id: productId,
          title: productTitle,
        });
        window.personalizationAnalysis.postInteractionData(
          'favorite',
          productId,
        );
        window.rtbHouseTracking.addToFavorite(productId);
      }

      Citiesocial.userManager.setUserFavoriteProductIds([
        ...currentUserFavoriteProductIdSet,
      ]);
      Citiesocial.utils.toggleClassName(targetHeartElement, 'active');
      const favoriteTextElement = targetHeartElement.querySelector(
        '.favorite__heart__content',
      );
      if (favoriteTextElement) {
        favoriteTextElement.textContent = isHeartActive ? '收藏' : '取消收藏';
        favoriteTextElement.style.color = isHeartActive ? '#00c795' : 'gray';
      }
    },
    checkProductIsUserFavorite: function (productId = null) {
      if (!productId) {
        return false;
      }
      const userFavoriteProductIdSet = Citiesocial.userManager.getUserFavoriteProductIdSet();
      return userFavoriteProductIdSet.has(productId);
    },
  },
  productManager: {
    getProductId: function () {
      return window.productPageData?.id || null;
    },
    productFormat: function (product) {
      const variants =
        typeof product.variants_json === 'string'
          ? JSON.parse(product.variants_json)
          : product.variants_json;
      const selectedVariant = Citiesocial.utils.getSelectedVariant(variants);

      return {
        id: product.shopify_id,
        is_available: product.is_available
          ? product.is_available
          : product.total_inventory_quantity_snapshot > 0,
        tags: product.shopify_tags,
        campaign_type: product.campaign_type,
        price: parseInt(selectedVariant.price),
        compare_at_price: parseInt(selectedVariant.compare_at_price),
        variantId: selectedVariant.id,
        handle: product.shopify_handle,
        title: product.shopify_title,
        brand: product.shopify_vendor,
        cover_image_url: product.cover_image_url,
      };
    },
    productFormatNew: function (product) {
      return {
        id: product.shopify_id,
        is_available: product.is_available,
        campaign_type: product.campaign_type,
        price: product.price,
        compare_at_price: product.compare_at_price,
        variantId: null,
        handle: product.handle,
        title: product.title,
        brand: product.brand,
        cover_image_url: product.cover_image_url,
      };
    },
    productFormatCayenne: function (product) {
      return {
        id: product.shopify_id,
        is_available: true,
        campaign_type: product.campaign_type,
        price: product.price,
        compare_at_price: product.compare_at_price,
        variantId: null,
        handle: product.handle,
        title: product.title,
        brand: product.brand,
        cover_image_url: product.cover_image_url,
      };
    },
    favoriteProductsFormat: function (product) {
      return {
        id: product.shopify_id,
        is_available: product.is_available,
        price: product.price,
        compare_at_price: product.compare_at_price,
        variantId: null,
        handle: product.handle,
        title: product.title,
        brand: product.brand,
        cover_image_url: product.cover_image_url,
      };
    },
    shopifyProductFormat: function (product) {
      return {
        id: product.id,
        is_available: product.available,
        price: product.price / 100,
        compare_at_price: product.compare_at_price / 100,
        variantId: null,
        handle: product.handle,
        title: product.title,
        brand: product.vendor,
        cover_image_url: product.featured_image,
        images: product.images,
        variants: product.variants.map((variant) => ({
          inventory_quantity: variant.inventory_quantity,
          option1: variant.option1,
          id: variant.id,
          shopify_id: variant.id,
          featured_media: variant.featured_media,
        })),
        media: product.media,
      };
    },
    productFormatForEarlyBird: function (product) {
      const isEarlyBird = true;
      const isEarlyBirdPreLaunch =
        new Date(product.available_at.replace(' ', 'T')).getTime() >
        new Date().getTime();
      const labels = [];
      const productStatus = product.inventory_quantity_status;

      if (productStatus) {
        if (productStatus.is_extreme_early_bird) {
          labels.push('超早鳥優惠');
        } else {
          labels.push('限量');
        }
        labels.push(`剩餘 ${productStatus.amount} 組`);
      }

      const countdown = Citiesocial.utils.countdown(
        product.deadline.replace(' ', 'T'),
      );
      const countdownLabelText = Citiesocial.utils.getCountdownLabelText(
        countdown,
      );
      labels.push(countdownLabelText);

      return {
        id: product.shopify_product_id,
        is_available:
          new Date(product.deadline.replace(' ', 'T')).getTime() -
            new Date().getTime() >
          0,
        tags: '',
        price: null,
        compare_at_price: null,
        variantId: null,
        handle: product.shopify_url.split('products/')[1],
        title: product.name,
        brand: product.brand_name,
        cover_image_url: product.image,
        is_early_bird: isEarlyBird,
        is_early_bird_pre_launch: isEarlyBirdPreLaunch,
        labels,
        questionnaire_url: product.questionnaire_url,
        order_count: product.order_count,
        total_amount: product.total_amount,
      };
    },
    projectFormatForFlashCollections: function (product) {
      const isFlashCollections = true;
      const labels = [];

      const countdown = Citiesocial.utils.countdown(
        product.end_datetime_utc.replace(' 15:59', 'T23:59:00+08:00'),
      );
      const countdownLabelText = Citiesocial.utils.getCountdownLabelText(
        countdown,
      );
      labels.push(countdownLabelText);

      if (product.is_extended) {
        labels.push('好評延長');
      }

      const category = product.primary_group
        ? product.primary_group.title
        : null;

      return {
        id: product.shopify_id,
        is_available: true,
        price: null,
        compare_at_price: null,
        variantId: null,
        handle: product.handle,
        title: product.title,
        brand: product.brand.name,
        cover_image_url: product.cover_image_src,
        is_flash_collections: isFlashCollections,
        labels,
        brand_country: product.brand.country,
        markdown_display: product.markdown_display,
        category,
        start_datetime: product.start_datetime_utc,
        end_datetime: product.end_datetime_utc,
      };
    },
    fetchProducts: async function (collection) {
      const {
        collectionHandle,
        collectionId,
        position,
        searchText,
        page = 1,
        limit = 48,
        collectionShopifyIds = '',
        searchOptions = {},
      } = collection;
      let fetchURL = `${PY3_API_BASE_URL}/api/v1.1/collection/${collectionId}/product-list/?page=${page}&limit=${limit}`;
      const urls = {
        // Top 100 在 carousel 版位，維持原來的 API 端點
        // https://app.asana.com/0/0/1128186909219334/1166577957758857/f
        [TOP_100_BEST_SELLING]:
          `${PY3_API_BASE_URL}/api/v1.2/product/ranking/` +
          `?limit=${position === 'carousel' ? '24' : '100'}`,
        [CAYENNE_RANKING]: `https://cayenne.citiesocial.com/cs/api/v1/search/product?page_size=30&category=${searchText}&cv=4`,
        [CROSS_SELLING_PRODUCTS]: `${PY3_API_BASE_URL}/api/v1.2/product/cross-selling/`,
        [EARLY_BIRD]: `${PY3_API_BASE_URL}/api/v1.1/early-bird/collection/`,
        [FLASH_COLLECTIONS]: `${PY3_API_BASE_URL}/api/v1.1/collection/flash-sale/?version=4`,
        [RECENTLY_VIEWED]: `${PY3_API_BASE_URL}/api/v1.1/shopify-domain/products/recently-viewed/`,
        [SEARCH_SUGGESTION]: `${PY3_SEARCH_API_BASE_URL}/cs/api/v1/search/suggestion?query=${searchText}&cv=4`,
        [SEARCH_PRODUCT]: `${PY3_SEARCH_API_BASE_URL}/cs/api/v1/search/product?${new URLSearchParams(
          searchOptions,
        ).toString()}&cv=4`,
        [PERSONALIZED_RECOMMENDATION]: `${PY3_API_BASE_URL}/api/v1.2/product/complete-search/personal/?page=${page}&seed=${
          Citiesocial.utils.getCookie('cs_seed') || 1
        }`,
        [MULTI_COLLECTION]: `${PY3_API_BASE_URL}/api/v1.2/collections/products/?${collectionShopifyIds}&page=1&page_size=96`,
        [PERSONALIZED_KEYWORD_RECOMMENDATION]: `${PY3_API_BASE_URL}/api/v1.2/product/complete-search/personal-category`,
        [PERSONALIZED_CATEGORY_RECOMMENDATION]: `${PY3_API_BASE_URL}/api/v1.2/product/complete-search/personal-category`,
      };
      if (collectionHandle in urls) {
        fetchURL = urls[collectionHandle];
      }
      let options = {};

      if (collectionHandle === RECENTLY_VIEWED) {
        const viewedProductIdArray = Citiesocial.productViewHistory.getViewedProductIdArray();
        if (viewedProductIdArray.length === 0) {
          $('#shopify-section-cs-recently-viewed').hide();
          return [];
        } else {
          options = {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: Citiesocial.utils.generateFormBody({
              shopify_product_ids: viewedProductIdArray.join(','),
              product_count: 20,
              format: 'json',
            }),
          };
        }
      }
      if (
        collectionHandle === PERSONALIZED_RECOMMENDATION ||
        collectionHandle === PERSONALIZED_KEYWORD_RECOMMENDATION ||
        collectionHandle === PERSONALIZED_CATEGORY_RECOMMENDATION
      ) {
        if (!Citiesocial.authManager.getAccessToken()) {
          $(`#shopify-section-1631519300c0990223`).hide();
          $(`#shopify-section-1652329771c705b966`).hide();
          $(`#shopify-section-16523298500c960f0f`).hide();
          return {
            products: [],
          };
        }
        options = {
          method: 'GET',
          headers: {
            Authorization: Citiesocial.authManager.getAuthorizationHeader(),
          },
        };
      }
      try {
        const response = await fetch(fetchURL, options);
        const responseJSON = await response.json();
        // 標準化 API 回傳的商品物件
        return Citiesocial.productManager.normalizeProducts(
          collection,
          responseJSON,
        );
      } catch (error) {
        console.log(error);
        return {
          products: [],
        };
      }
    },
    normalizeProducts: function (collection, response) {
      const { collectionHandle } = collection;

      const handleNormalize = {
        [TOP_100_BEST_SELLING](response) {
          return {
            pageInfo: null,
            products: response.results.products.map((product) =>
              Citiesocial.productManager.productFormatNew(product),
            ),
          };
        },
        [CAYENNE_RANKING](response) {
          return {
            pageInfo: response.page_info,
            products: response.results.map((product) =>
              Citiesocial.productManager.productFormatCayenne(product),
            ),
          };
        },
        [CROSS_SELLING_PRODUCTS](response) {
          return {
            pageInfo: null,
            products: response.results.map((product) =>
              Citiesocial.productManager.productFormat(product),
            ),
          };
        },
        [EARLY_BIRD](response) {
          return {
            pageInfo: null,
            products: response.results.map((product) =>
              Citiesocial.productManager.productFormatForEarlyBird(product),
            ),
          };
        },
        [FLASH_COLLECTIONS](response) {
          const products = response.results
            .map((product) =>
              Citiesocial.productManager.projectFormatForFlashCollections(
                product,
              ),
            )
            .sort(
              (a, b) => new Date(b.start_datetime) - new Date(a.start_datetime),
            );
          return {
            pageInfo: null,
            products,
          };
        },
        [RECENTLY_VIEWED](response) {
          return {
            pageInfo: null,
            products: response.map((product) => ({
              ...product,
              tags: '',
              is_available: true,
              brand: product.vendor,
            })),
          };
        },
        [SEARCH_SUGGESTION](response) {
          return {
            brands: response.brands,
            categories: response.categories,
            tags: response.keywords,
            products: response.products,
          };
        },
        [SEARCH_PRODUCT](response) {
          return {
            pageInfo: response.page_info,
            products: response.results.map((product) =>
              Citiesocial.productManager.productFormatNew({
                ...product,
                // 新版搜尋 API 後端已過濾掉下架商品，這邊為了通用先直接給 true
                is_available: true,
              }),
            ),
          };
        },
        [PERSONALIZED_RECOMMENDATION](response) {
          if (
            response.error?.name === 'ExpiredTokenError' ||
            response.error?.name === 'TypeError'
          ) {
            if (response.error?.name === 'ExpiredTokenError') {
              Citiesocial.utils.removeCookie('cs_token');
              Citiesocial.utils.removeCookie('cs_token_flag');
              localStorage.removeItem('cs_id_token');
              localStorage.removeItem('cs_access_token');
              localStorage.removeItem('cs_refresh_token');
              localStorage.removeItem('shopifyCustomerAccessToken');
            }
            $(`#shopify-section-1631519300c0990223`).hide();
            return {
              pageInfo: null,
              products: [],
            };
          } else {
            return {
              pageInfo: response.results.page_info,
              products: response.results.products.map((product) =>
                Citiesocial.productManager.productFormatNew(product),
              ),
            };
          }
        },
        [MULTI_COLLECTION](response) {
          return {
            collections: response.results.map((collections) => ({
              id: collections.collection_shopify_id,
              title: collections.title,
              handle: collections.handle,
              products: collections['products'].map((product) =>
                Citiesocial.productManager.productFormatNew(product),
              ),
            })),
          };
        },
        [PERSONALIZED_KEYWORD_RECOMMENDATION](response) {
          if (
            response.error?.name === 'ExpiredTokenError' ||
            response.error?.name === 'TypeError'
          ) {
            if (response.error?.name === 'ExpiredTokenError') {
              Citiesocial.utils.removeCookie('cs_token');
              Citiesocial.utils.removeCookie('cs_token_flag');
              localStorage.removeItem('cs_id_token');
              localStorage.removeItem('cs_access_token');
              localStorage.removeItem('cs_refresh_token');
              localStorage.removeItem('shopifyCustomerAccessToken');
            }
            $(`#shopify-section-1652329771c705b966`).hide();
            $(`#shopify-section-16523298500c960f0f`).hide();
            return {
              pageInfo: null,
              products: [],
            };
          } else {
            // 避免取到重複的分類項目
            localStorage.setItem(
              'categoryCarousel',
              response.results.products_list[0].category_title,
            );
            return {
              pageInfo: response.results.products_list[0].page_info,
              products: response.results.products_list[0].products.map(
                (product) =>
                  Citiesocial.productManager.productFormatNew(product),
              ),
              categoryTitle: response.results.products_list[0].category_title,
            };
          }
        },
        [PERSONALIZED_CATEGORY_RECOMMENDATION](response) {
          // 避免取到重複的分類項目
          const firstCategoryCarousel = localStorage.getItem(
            'categoryCarousel',
          );
          const categoryCarousel =
            response.results.products_list[0].category_title;
          const index = firstCategoryCarousel === categoryCarousel ? 1 : 0;
          return {
            pageInfo: response.results.products_list[index].page_info,
            products: response.results.products_list[
              index
            ].products.map((product) =>
              Citiesocial.productManager.productFormatNew(product),
            ),
            categoryTitle: response.results.products_list[index].category_title,
          };
        },
      };

      if (collectionHandle in handleNormalize) {
        return handleNormalize[collectionHandle](response);
      } else {
        return {
          pageInfo: response.results.page_info,
          products: response.results.products.map((product) =>
            Citiesocial.productManager.productFormatNew(product),
          ),
        };
      }
    },
    fetchAllCategories: async function () {
      const response = await fetch(
        `${PY3_API_BASE_URL}/api/v1.1/category/categories/?version=4`,
      );
      const responseJSON = await response.json();
      return responseJSON || {};
    },
    fetchFrequentlyBoughtTogetherProducts: async function (productId = '') {
      if (!productId) {
        return [];
      }
      const response = await fetch(
        `${PY3_API_BASE_URL}/api/v1.2/product/frequently-bought-together/?product_id=${productId}`,
      );
      const responseJson = await response.json();
      return responseJson.results.map((product) =>
        Citiesocial.productManager.productFormat(product),
      );
    },
    makeProductCardsHTML: function (
      products = [],
      collection = {},
      {
        productLimit = null,
        shouldShowUnAvailableProduct = false,
        shouldShowQuickShop = false,
        isOpenLinkInNewTab = false,
        ref = null,
      },
    ) {
      let productsCardsHTML = '';
      let productCount = 1;
      const { collectionHandle } = collection;

      const length = products.length;
      for (let i = 0; i < length; i++) {
        if (productLimit && productCount > productLimit) {
          break;
        }

        const {
          id,
          is_available,
          price,
          compare_at_price,
          handle,
          title,
          brand,
          cover_image_url,
          is_early_bird,
          is_early_bird_pre_launch,
          labels,
          questionnaire_url,
          order_count,
          total_amount,
          is_flash_collections,
          brand_country,
        } = products[i];

        if (!is_available && !shouldShowUnAvailableProduct) {
          continue;
        }

        const isProductOnSale = compare_at_price > price;
        const isTop100Collection =
          collectionHandle === TOP_100_BEST_SELLING ||
          collectionHandle === CAYENNE_RANKING;

        let productCardClassModifier = '';
        if (is_early_bird) {
          productCardClassModifier = 'product-card--early-bird';
        } else if (is_flash_collections) {
          productCardClassModifier = 'product-card--flash-collections';
        }

        let link = '';
        if (is_early_bird_pre_launch) {
          link = questionnaire_url;
        } else if (is_flash_collections) {
          link = `https://www.citiesocial.com/collections/${handle}?ref=${
            ref || collectionHandle
          }`;
        } else {
          link = `https://www.citiesocial.com/products/${handle}?ref=${
            ref || collectionHandle
          }`;
        }
        const targetProperty =
          is_early_bird_pre_launch || isOpenLinkInNewTab
            ? `target="_blank"`
            : '';

        const indexNumberHTML = isTop100Collection
          ? `<div class="product-card__index-number">${productCount}</div>`
          : ``;

        const productImageHTML = `<img loading="lazy" src="${cover_image_url}"/>`;

        const comingSoonOverlayHTML = is_early_bird_pre_launch
          ? `<div class="product-card__coming-soon-overlay">
              <div class="overlay__title">COMING SOON</div>
              <div class="overlay__content">填問卷搶先看 →</div>
            </div>`
          : '';

        let labelsHTML = '';
        if (is_early_bird_pre_launch) {
          labelsHTML += `<div class="label label--secondary">即將上線</div>`;
        } else if (labels) {
          labels.forEach((label) => {
            labelsHTML += `<div class="label label--primary">${label}</div>`;
          });
        }

        const earlyBirdStatsHTML =
          is_early_bird && !is_early_bird_pre_launch
            ? `<div class="product-card__early-bird-stats">
                  購買人數 ${Citiesocial.utils.formatNumber(
                    order_count,
                  )} 人  |  累計金額
                  <span data-money-convertible data-base-value="${total_amount}" data-base-currency="TWD">
                    <span class="money">
                      ${Citiesocial.utils.getCurrency(total_amount)}
                    </span>
                  </span>
                </div>`
            : '';

        let priceSectionHTML = price
          ? `
          <div class="product-card__price" data-money-convertible data-base-value="${price}" data-base-currency="TWD">
            <span class="money">
              ${Citiesocial.utils.getCurrency(price)}
            </span>
          </div>`
          : '';
        if (isProductOnSale) {
          priceSectionHTML += `<del class="product-card__compare-at-price" data-money-convertible data-base-value="${compare_at_price}" data-base-currency="TWD">
              <span class="money">
                ${Citiesocial.utils.getCurrency(compare_at_price)}
              </span>
            </del>`;
        }

        let brandCountryText = '';
        if (
          is_flash_collections &&
          brand_country &&
          brand_country != '中國' &&
          brand_country != '其他'
        ) {
          brandCountryText = `${brand_country}, `;
        }

        let favoriteHeartHTML = '';
        if (
          !is_early_bird &&
          !is_flash_collections &&
          !navigator.userAgent.includes('cs_webview')
        ) {
          favoriteHeartHTML = `<div class="favorite__heart" data-product-id="${id}" data-product-title="${title.replaceAll(
            '"',
            '',
          )}">
            <i class="cs_icon icon-heart-solid"></i>  
            <i class="cs_icon icon-heart-outline"></i>
          </div>`;
        }

        let quickShopHTML = '';
        if (shouldShowQuickShop) {
          if (is_available) {
            quickShopHTML = `<div class="cs-productItem-quickAddWrapper text-center">
                            <div class="cs-productItem-imageWrapper-quckshopOverlay cs-productItem-quickAddWrapper-button" data-action="open-quick-shop" data-quick-shop-url="/products/${handle}?view=quick_shop" data-product-id="${id}">
                              <div class="cs-productItem-quickAddWrapper-text">
                                <i class="cs_icon icon-shopping-cart"></i>
                                <span> 購買</span>
                              </div>
                            </div>
                          </div>`;
          } else {
            quickShopHTML = `<div class="cs-productItem-quickAddWrapper"></div>`;
          }
        }

        productsCardsHTML += `<div class="product-card ${productCardClassModifier}" data-product-id="${id}" ${
          is_available ? '' : 'style="opacity:0.5;"'
        } >
                                <a href="${link}" ${targetProperty}>
                                  ${indexNumberHTML}
                                  <div class="product-card__image">
                                    ${productImageHTML}
                                    ${
                                      is_available
                                        ? ''
                                        : '<div class="sold-out">已售完</div>'
                                    }
                                    ${comingSoonOverlayHTML}
                                    ${favoriteHeartHTML}
                                  </div>
                                </a>
                                <p class="product-card__vendor">
                                  ${brandCountryText}
                                  <a href="/pages/in-house-search-results-page?type=brand&q=${encodeURIComponent(
                                    brand,
                                  )}">
                                    ${brand}
                                  </a>
                                </p>
                                <a class="product-card__content" href="${link}" ${targetProperty}>
                                  <h5 class="product-card__title">${title}</h5>
                                  <div class="product-card__labels">${labelsHTML}</div>
                                  ${earlyBirdStatsHTML}
                                  ${priceSectionHTML}
                                </a>
                                ${quickShopHTML}
                              </div>`;

        productCount++;
      }
      return productsCardsHTML;
    },
    makeOwlCarouselOptions: function (
      collectionHandle,
      isDesktopCollectionMode,
    ) {
      const owlCarouselOptions = {
        rewind: true,
        margin: 0,
        slideBy: 1,
        dots: false,
        items: 2,
        responsive: {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: {
            margin: 12,
            items: getOwlCarouselShowItems(
              collectionHandle,
              isDesktopCollectionMode,
              RESPONSIVE_MIDDLE_BREAKING_POINT,
            ),
            slideBy: 'page',
            nav: true,
            navText: [
              '<i class="cs_icon icon-arrow-left"></i>',
              '<i class="cs_icon icon-arrow-right"></i>',
            ],
          },
          [RESPONSIVE_LARGE_BREAKING_POINT]: {
            margin: 12,
            items: getOwlCarouselShowItems(
              collectionHandle,
              isDesktopCollectionMode,
              RESPONSIVE_LARGE_BREAKING_POINT,
            ),
            slideBy: 'page',
            nav: true,
            navText: [
              '<i class="cs_icon icon-arrow-left"></i>',
              '<i class="cs_icon icon-arrow-right"></i>',
            ],
          },
        },
      };

      function getOwlCarouselShowItems(
        collectionHandle,
        isDesktopCollectionMode,
        breakingPoint,
      ) {
        const earlyBirdShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: isDesktopCollectionMode ? 1 : 2,
          [RESPONSIVE_LARGE_BREAKING_POINT]: isDesktopCollectionMode ? 2 : 3,
        };
        const flashCollectionsShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: isDesktopCollectionMode ? 2 : 3,
          [RESPONSIVE_LARGE_BREAKING_POINT]: isDesktopCollectionMode ? 3 : 4,
        };
        const brandShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: isDesktopCollectionMode ? 2 : 3,
          [RESPONSIVE_LARGE_BREAKING_POINT]: isDesktopCollectionMode ? 3 : 5,
        };
        const topic2ShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: 4,
          [RESPONSIVE_LARGE_BREAKING_POINT]: 4,
        };
        const topic3ShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: 3,
          [RESPONSIVE_LARGE_BREAKING_POINT]: 3,
        };
        const generalShowItems = {
          [RESPONSIVE_MIDDLE_BREAKING_POINT]: isDesktopCollectionMode ? 2 : 4,
          [RESPONSIVE_LARGE_BREAKING_POINT]: isDesktopCollectionMode ? 4 : 6,
        };
        if (collectionHandle === EARLY_BIRD) {
          return earlyBirdShowItems[breakingPoint];
        } else if (collectionHandle === FLASH_COLLECTIONS) {
          return flashCollectionsShowItems[breakingPoint];
        } else if (collectionHandle === BRAND) {
          return brandShowItems[breakingPoint];
        } else if (collectionHandle === TOPIC_2) {
          return topic2ShowItems[breakingPoint];
        } else if (collectionHandle === TOPIC_3) {
          return topic3ShowItems[breakingPoint];
        } else {
          return generalShowItems[breakingPoint];
        }
      }

      return owlCarouselOptions;
    },
    initProductSlideshow: function ($productSlideshow) {
      if (!$productSlideshow.length) {
        return;
      }
      const isZoomEnabled = Citiesocial.utils.isMobile()
        ? false
        : JSON.parse($productSlideshow.attr('data-zoom-enabled'));
      const zoomMagnification = $productSlideshow.attr(
        'data-zoom-magnification',
      );
      const isShowArrows = JSON.parse(
        $productSlideshow.attr('data-show-arrows'),
      );
      const isShowDots = JSON.parse($productSlideshow.attr('data-show-dots'));

      $productSlideshow.on('init afterChange', function (event, slick) {
        const $currentSlide = $(slick.$slides[slick.currentSlide]);

        if (isZoomEnabled && !$currentSlide.attr('data-slide-initialized')) {
          $currentSlide.zoom({
            url: $currentSlide.attr('data-image-large-url'),
            touch: false,
            magnify: zoomMagnification,
            onZoomIn: function () {
              $(this).prev().addClass('product__slideshow-image--zoomed');
            },
            onZoomOut: function () {
              $(this).prev().removeClass('product__slideshow-image--zoomed');
            },
          });
        }
      });

      $productSlideshow.slick({
        autoplay: false,
        adaptiveHeight: true,
        arrows: isShowArrows,
        dots: isShowDots,
        fade: $productSlideshow.attr('data-rotation-effect') === 'fade',
        mobileFirst: true,
        touchThreshold: 4,
        initialSlide: 0,
        prevArrow:
          '<div class="slick-prev"><i class="cs_icon icon-arrow-left"></i></div>',
        nextArrow:
          '<div class="slick-next"><i class="cs_icon icon-arrow-right"></i></div>',
      });

      // Thumbnails
      $productSlideshow
        .next('.product__thumbnails')
        .find('.product__thumbnail')
        .on('click', function () {
          $productSlideshow.slick('slickGoTo', $(this).attr('data-index'));
          return false;
        });
    },
    // 這邊要把 campaign_type = flash_sale 的商品轉成 flash_sales
    modifyCampaignType(json) {
      const data = json;

      if (data.campaign_type === 'flash_sale') {
        data.campaign_type = 'flash_sales';
      }

      return data;
    },
    getCsProduct: async function (product_id) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/api/v1.1/product/by-shopify-id/${product_id}/?version=4`,
      );
      const responseJSON = await response.json();
      // 這邊要把 campaign_type = flash_sale 的商品轉成 flash_sales
      const transferData = this.modifyCampaignType(responseJSON);

      return transferData;
    },
    getCsVariants: async function (variants_id) {
      const response = await fetch(
        `${PY3_API_BASE_URL}/api/v1.1/product/variants/by-shopify-ids/?shopify_ids=${variants_id.join()}&version=4`,
      );
      const responseJSON = await response.json();
      const convertArrayToObject = (array, key) =>
        array.reduce(
          (obj, item) => ({
            ...obj,
            [item[key]]: item,
          }),
          {},
        );
      // 沒設定 Variant Title 的商品，系統預設會給 Default Title，這邊要把它改成空字串
      responseJSON.results.variants.forEach((variant) => {
        if (variant.title === 'Default Title') {
          variant.title = '';
        }
        variant.product = this.modifyCampaignType(variant.product);
      });

      return convertArrayToObject(
        responseJSON.results.variants,
        'shopify_variant_id',
      );
    },
    displayProducts: async function (collection, collectionProducts) {
      const {
        sectionId,
        collectionHandle,
        desktopMode,
        mobileMode,
        isEarlyBird,
        isFlashCollections,
        referralLabel,
      } = collection;
      const isDesktopCollectionMode = desktopMode === 'collection';
      const isMobileListMode = mobileMode === 'list';
      // const stopLazyLoadingHeightPoint = 1200;

      // 因為 NORMAL_CAROUSEL_ITEM_LIMIT = 24 及考慮到不同國家站有部分商品不會顯示，抓安全係數為 4，因此設定 limit 為 24 x 4 = 96
      const { products, categoryTitle } =
        collectionProducts === undefined
          ? await Citiesocial.productManager.fetchProducts({
              ...collection,
              limit: 96,
            })
          : collectionProducts;
      // 處理推薦分類的 title 和更多XXX的 href
      if (categoryTitle) {
        $(`#${sectionId}`)
          .find('.carousel__header-title')
          .html(`為你推薦：${categoryTitle.replace('所有', '')}`);
        $(`#${sectionId}`)
          .find('.carousel__header-read-more')
          .attr(
            'href',
            `/pages/in-house-search-results-page?type=category&q=${categoryTitle}`,
          );
      }
      // 若為超值加購商品列，隨機打亂順序
      if (collectionHandle === CROSS_SELLING_PRODUCTS) {
        Citiesocial.utils.shuffle(products);
      }

      let productLimit = NORMAL_CAROUSEL_ITEM_LIMIT;
      if (isEarlyBird) {
        productLimit = EARLY_BIRD_CAROUSEL_ITEM_LIMIT;
      }
      if (isFlashCollections) {
        productLimit = FLASH_COLLECTIONS_CAROUSEL_ITEM_LIMIT;
      }

      if (window.innerWidth >= RESPONSIVE_MIDDLE_BREAKING_POINT) {
        const $targetElement = $(`#${sectionId}-owl-carousel`);

        const productCardsForDesktopHTML = Citiesocial.productManager.makeProductCardsHTML(
          products,
          collection,
          {
            productLimit,
            ref: referralLabel,
          },
        );
        $targetElement.removeClass('carousel-skeleton-grid');
        $targetElement.html(productCardsForDesktopHTML);

        const owlCarouselOptions = Citiesocial.productManager.makeOwlCarouselOptions(
          collectionHandle,
          isDesktopCollectionMode,
        );
        $targetElement.owlCarousel(owlCarouselOptions);
      } else {
        if (isMobileListMode) {
          productLimit = NORMAL_CAROUSEL_MOBILE_LIST_MODE_ITEM_LIMIT;
        }

        const $targetElement = $(`#${sectionId} .list__list`);

        const productCardsForMobileHTML = Citiesocial.productManager.makeProductCardsHTML(
          products,
          collection,
          {
            productLimit,
            ref: referralLabel,
          },
        );
        $targetElement.html(productCardsForMobileHTML);
      }

      Citiesocial.favoriteManager.start();
    },
    displayEarlyBirdSameCategoryCollectionCarousel: async function ({
      categoryTitle,
      earlyBirdProjectId,
    }) {
      // 如果有客製化的早鳥顯示 Carousel，就不顯示同分類商品
      // https://docs.google.com/document/d/1ET901qvQOTTjfIfgo_XjCyNZDIaB86M0b9rErwhm_oo/edit?usp=sharing
      if ($('#early-bird-carousel').length) {
        $('#index_carousel_3').hide();
        return;
      }

      const collection = window.apiBasedCarousel.find(
        ({ collectionHandle }) => collectionHandle === EARLY_BIRD_RECOMMENDED,
      );
      let { products } = await Citiesocial.productManager.fetchProducts({
        collectionHandle: SEARCH_PRODUCT,
        searchOptions: { category: categoryTitle },
      });
      products = products.filter(
        (product) => String(product.id) !== String(earlyBirdProjectId),
      );
      if (!products.length) {
        $('#index_carousel_3').hide();
        return;
      }

      Citiesocial.productManager.displayProducts(collection, { products });

      const $targetCarousel = $(`#${collection.sectionId}`);
      $targetCarousel
        .find('.carousel__header-read-more')
        .attr(
          'href',
          `https://www.citiesocial.com/pages/in-house-search-results-page?type=category&q=${encodeURIComponent(
            categoryTitle,
          )}`,
        );
      const collectionTitle = $targetCarousel
        .find('.carousel__header-title')
        .text();
      window.segmentTracking.carouselView(
        collection.collectionHandle,
        collectionTitle,
        collection.sectionId,
      );
      $(
        `#${collection.sectionId} .carousel__wrapper, #${collection.sectionId} .list__wrapper`,
      ).on('click', 'a', () => {
        window.segmentTracking.carouselClicked(
          collection.collectionHandle,
          $(`#${collection.sectionId}`).find('.carousel__header-title').text(),
          collection.sectionId,
          'product_card',
        );
      });
    },
  },
  eventManager: {
    addedToCart: function (collectionIds) {
      var url = `${PY3_API_BASE_URL}/api/v1.1/shopify-domain/events/added-to-cart/`;
      var postData = {
        collection_ids: collectionIds,
      };
      $.ajax({
        url: url,
        cache: false,
        type: 'POST',
        datatype: 'json',
        data: postData,
      });
    },
  },
  cartManager: {
    quickAddToCart: function (elem, variantId) {
      $.post({
        url: '/cart/add.js',
        data: { id: variantId },
        dataType: 'json',
      })
        .then(function (result) {
          // start of tracking
          window.segmentTracking.productAdded(result);
          window.personalizationAnalysis.postInteractionData(
            'cart',
            result.product_id,
          );
          // end of tracking

          // POST/PUT CS-CART
          // Citiesocial.cartManager.asyncCsCart(
          //   window.cart_token ? 'PUT' : 'POST',
          // );

          // We close quick shop if one is open
          if (window.quickShopRemodalInstance) {
            window.quickShopRemodalInstance.close();
          }
          // We throw an event so that our mini-cart can do additional processing like re-rendering the mini-cart
          $(document).trigger('product.added');

          // LINE
          window._lt(
            'send',
            'cv',
            {
              type: 'AddToCart',
            },
            ['e8f31b4a-196f-47ea-b140-0c4954426c79'],
          );
        })
        .catch(function (error) {
          alert(error.responseJSON.description);
        });
    },
    addToCart: function (items = []) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON,
        },
        body: JSON.stringify({
          items,
        }),
      });
    },
    getCartJson: async function () {
      const cartResponse = await fetch('/cart.json');
      return cartResponse.json();
    },
    asyncIterableCart: async function () {
      $.getJSON('/cart.js', function (data) {
        const iterableProducts = [];
        for (let item of data.items) {
          iterableProducts.push({
            variant_id: item.variant_id.toString(),
            quantity: item.quantity,
          });
        }
        $.ajax({
          type: 'POST',
          url: `${PY3_API_BASE_URL}/api/v1.1/iterable/shopping-cart/`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({
            shopify_user_id: window.customer.id,
            email: window.customer.email,
            products: iterableProducts,
          }),
        });
      });
    },
    asyncCsCart: async function (action) {
      const cart_token = JSON.stringify({
        cart_token: Citiesocial.utils.getCookie('cart'),
      });
      const csToken = Citiesocial.authManager.getAccessToken();
      if (csToken === undefined) {
        return '';
      }
      return $.ajax({
        type: action,
        url: `${PY3_API_BASE_URL}/api/v1.1/customer/cart-mapping/`,
        headers: {
          Authorization: Citiesocial.authManager.getAuthorizationHeader(),
        },
        dataType: 'json',
        contentType: 'application/json',
        data: action === 'POST' || action === 'PUT' ? cart_token : '',
        success: function (response) {
          if (response.error?.name === 'ExpiredTokenError') {
            Citiesocial.utils.removeCookie('cs_token');
            Citiesocial.utils.removeCookie('cs_token_flag');
            localStorage.removeItem('cs_id_token');
            localStorage.removeItem('cs_access_token');
            localStorage.removeItem('cs_refresh_token');
            localStorage.removeItem('shopifyCustomerAccessToken');
          }
          if (action === 'GET' && response.results?.cart_token) {
            Citiesocial.utils.removeCookie('cart');
            Citiesocial.utils.setCookie(
              'cart',
              response.results.cart_token,
              14,
            );
            window.cart_token = response.results.cart_token;
            $(document).trigger('miniCart.rerender');
            Citiesocial.cartManager.mergeCart();
            setTimeout(() => {
              Citiesocial.utils.setCookie('cart', response.results.cart_token);
            }, 3000);
          }
          return response;
        },
        error: function (err) {
          if (err.responseText === 'Token Verification Failed.') {
            Citiesocial.utils.removeCookie('cs_token');
            Citiesocial.utils.removeCookie('cs_token_flag');
            localStorage.removeItem('cs_id_token');
            localStorage.removeItem('cs_access_token');
            localStorage.removeItem('cs_refresh_token');
            localStorage.removeItem('shopifyCustomerAccessToken');
          }
          return '';
        },
      });
    },
    mergeCart: async function () {
      // if (
      //   Citiesocial.userManager.isLogin() &&
      //   Citiesocial.utils.getCookie('csProducts')
      // ) {
      //   const csProducts = JSON.parse(
      //     Citiesocial.utils.getCookie('csProducts'),
      //   );
      //   Citiesocial.utils.removeCookie('csProducts');
      //   await Citiesocial.cartManager.addToCart(csProducts);
      //   $(document).trigger('miniCart.rerender');
      // }
      return false;
    },
    getDiscountCode: function ({ cartTotalPrice = null }) {
      const groupBuyingCampaignCode = Citiesocial.utils.getCookie(
        'group_buying_campaign_code',
      );
      const welfareCouponCode = Citiesocial.utils.getCookie('welfare-coupon');
      const welfareCouponCode2 = Citiesocial.utils.getCookie(
        'welfare-coupon-2',
      );

      if (groupBuyingCampaignCode) {
        return groupBuyingCampaignCode;
      } else if (
        cartTotalPrice >= 2500 &&
        welfareCouponCode2?.includes('wistron')
      ) {
        return welfareCouponCode2;
      } else if (
        cartTotalPrice >= 2000 &&
        welfareCouponCode2?.includes('mizuho')
      ) {
        return welfareCouponCode2;
      } else if (cartTotalPrice >= 1000 && welfareCouponCode) {
        return welfareCouponCode;
      } else {
        return null;
      }
    },
    displayAddToCartSuccessfully: function () {
      const element = document.querySelector('.pop-up-add-to-cart-successful');

      if (!element) return false;

      element.style.display = 'flex';
      setTimeout(() => {
        element.style.opacity = 1;
      }, 10);

      setTimeout(() => {
        element.style.opacity = 0;

        setTimeout(() => {
          element.style.display = 'none';
        }, 250);
      }, 1000 + 250);

      return false;
    },
    applyDiscount: async function ({ code }) {
      const response = await fetch(
        `https://cs-shopify-discount-use.glitch.me/api/apply/${code}`,
      );
      return await response.json();
    },
    checkDiscount: async function ({ code }) {
      const response = await fetch(
        `https://cs-shopify-discount-use.glitch.me/api/get/${code}`,
      );
      return await response.json();
    },
    getCheckoutUrl: async function ({
      shippingInfo,
      items,
      discountCode,
      note,
    }) {
      const NEW_ADDRESS = 'new';
      const customerAccessToken = localStorage.getItem(
        'shopifyCustomerAccessToken',
      );
      const client = Citiesocial.storefrontApiManager.getClient();
      let shouldPrefillAddress = true;

      if (!shippingInfo?.selectedAddressId) {
        shouldPrefillAddress = false;
      }

      if (
        Citiesocial.userManager.isLogin() &&
        customerAccessToken &&
        shippingInfo?.selectedAddressId
      ) {
        let targetAddressId = null;
        shouldPrefillAddress = false;

        if (shippingInfo.selectedAddressId === NEW_ADDRESS) {
          const {
            data: customerAddressCreateData,
            errors: customerAddressCreateErrors,
          } = await client.request(
            Citiesocial.storefrontApiManager.mutation.customerAddressCreate,
            {
              variables: {
                address: {
                  address2: shippingInfo.city,
                  city: shippingInfo.district,
                  address1: shippingInfo.address,
                  company: '',
                  country: 'Taiwan',
                  firstName: shippingInfo.firstName,
                  lastName: shippingInfo.lastName,
                  phone: shippingInfo.phone,
                  province: '',
                  zip: shippingInfo.zip,
                },
                customerAccessToken,
              },
            },
          );

          targetAddressId =
            customerAddressCreateData?.customerAddressCreate?.customerAddress
              ?.id;

          if (customerAddressCreateErrors) {
            shouldPrefillAddress = true;
          }
        } else {
          targetAddressId = shippingInfo.selectedAddressId;
        }

        // 更新預設地址
        const {
          errors: customerDefaultAddressUpdateErrors,
        } = await client.request(
          Citiesocial.storefrontApiManager.mutation
            .customerDefaultAddressUpdate,
          {
            variables: {
              addressId: targetAddressId,
              customerAccessToken,
            },
          },
        );

        if (customerDefaultAddressUpdateErrors) {
          shouldPrefillAddress = true;
        }
      }

      const utmData = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_term: '',
        utm_content: '',
      };
      const firstTouchUTMData = Citiesocial.utils.getCookie(
        FIRST_TOUCH_UTM_COOKIE_NAME,
      );

      if (firstTouchUTMData) {
        try {
          const parsedData =
            Citiesocial.utils.safeJsonParse(firstTouchUTMData) || {};
          Object.assign(utmData, parsedData);
        } catch (error) {
          console.error('Error parsing UTM data:', error);
        }
      }

      const { data: cartCreateData, errors } = await client.request(
        Citiesocial.storefrontApiManager.mutation.cartCreate,
        {
          variables: {
            input: {
              lines: items.map(({ variant_id: variantId, quantity }) => ({
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                quantity,
              })),
              discountCodes: discountCode ? [discountCode] : [],
              buyerIdentity: {
                countryCode: 'TW',
                email: window.customer?.email,
                ...(shouldPrefillAddress && {
                  deliveryAddressPreferences: [
                    {
                      deliveryAddress: {
                        address2: shippingInfo.city,
                        city: shippingInfo.district,
                        address1: shippingInfo.address,
                        company: '',
                        country: 'Taiwan',
                        firstName: shippingInfo.firstName,
                        lastName: shippingInfo.lastName,
                        phone: shippingInfo.phone,
                        province: '',
                        zip: shippingInfo.zip,
                      },
                    },
                  ],
                }),
              },
              attributes: [
                {
                  key: '__cs_step',
                  value: 'payment',
                },
                {
                  key: '__cs_geo',
                  value: 'TW',
                },
                {
                  key: '__cs_checkout_device',
                  value: 'browser',
                },
                {
                  key: '__cs_channel_data',
                  value: Cookies.get('__cs_channel_data') || 'citiesocial',
                },
                {
                  key: '__cs_checkout_type',
                  value: 'cart',
                },
                {
                  key: '__cs_checkout_version',
                  value: 'beta',
                },
                {
                  key: '__cs_checkout_is_guest_purchase',
                  value: `${!window.customer}`,
                },
                {
                  key: '__cs_segment_anonymousId',
                  value: `${Citiesocial.userManager.getSegmentAnonymousId()}`,
                },
                {
                  key: '__cs_checkout_platform',
                  value: 'web',
                },
                {
                  key: '__cs_checkout_invoice',
                  value: Citiesocial.utils.safeJsonStringify({
                    invoiceType: String(shippingInfo?.invoiceType ?? ''),
                    donationUnit: String(shippingInfo?.donationUnit ?? ''),
                    invoiceTitle: String(shippingInfo?.invoiceTitle ?? ''),
                    invoiceAddress: String(shippingInfo?.invoiceAddress ?? ''),
                    invoiceCity: String(shippingInfo?.invoiceCity ?? ''),
                    invoiceDistrict: String(
                      shippingInfo?.invoiceDistrict ?? '',
                    ),
                    invoiceZip: String(shippingInfo?.invoiceZip ?? ''),
                    invoicePhone: String(shippingInfo?.invoicePhone ?? ''),
                    unifiedNumber: String(shippingInfo?.unifiedNumber ?? ''),
                  }),
                },
                {
                  key: '__cs_first_touch_utm',
                  value: Citiesocial.utils.safeJsonStringify(utmData),
                },
              ],
              note,
            },
          },
        },
      );

      if (errors) {
        return { errors };
      }

      if (cartCreateData?.cartCreate?.userErrors?.length) {
        window.segmentTracking.cartCreateUserErrors({
          error: JSON.stringify(cartCreateData),
        });

        const errorMessages = cartCreateData.cartCreate.userErrors.map(
          (error) => error.message,
        );

        if (errorMessages.includes('Email 無效')) {
          if (
            window.confirm(
              `很抱歉😱 😣 🙏\n您的帳號 ${window.customer?.email} 信箱似乎是無效的，會無法收到訂單確認與優惠通知。\n\n別擔心，這可能是拼字錯誤或信箱已停用，我們可以使用訪客模式繼續完成結帳！`,
            )
          ) {
            window.customer = void 0; // 好讓 Citiesocial.userManager.isLogin() 返回 false
            await Citiesocial.authManager.logout();
            Citiesocial.authManager.clearToken();

            return Citiesocial.cartManager.getCheckoutUrl({
              shippingInfo,
              items,
              discountCode,
              note,
            });
          }
        }
      }

      return { checkoutUrl: cartCreateData?.cartCreate?.cart?.checkoutUrl };
    },
  },
  productViewHistory: {
    bucketSize: 20,
    cookieName: '__cs_pvh_2wert89oikjhgx',
    addProductView: function (productId) {
      // clean legacy cookies
      Cookies.remove('__cs_pvh_2wert89oikjhg');

      var viewedProductIdArray = Citiesocial.productViewHistory.getViewedProductIdArray();
      if (viewedProductIdArray == null) {
        //initializing empty array
        viewedProductIdArray = [];
      } else if (typeof viewedProductIdArray == 'string') {
        //reformatting string to array
        viewedProductIdArray = viewedProductIdArray.split(',');
      }

      var index = viewedProductIdArray.indexOf(productId);
      if (index > -1) {
        viewedProductIdArray.splice(index, 1);
      }
      viewedProductIdArray.unshift(productId);
      viewedProductIdArray = viewedProductIdArray.slice(0, this.bucketSize);
      Citiesocial.utils.setCookie(this.cookieName, viewedProductIdArray, 1000);
      return viewedProductIdArray;
    },
    getViewedProductIdArray: function () {
      var viewedProductIdArray = Cookies.getJSON(
        Citiesocial.productViewHistory.cookieName,
      );
      if (viewedProductIdArray == null) {
        viewedProductIdArray = [];
      } else if (typeof viewedProductIdArray == 'string') {
        viewedProductIdArray = viewedProductIdArray.split(',');
      }

      return viewedProductIdArray.slice(0, this.bucketSize);
    },
    getProductsRecentlyViewed: function (displayCount, callbackFunction) {
      var viewedProductIdArray = this.getViewedProductIdArray();
      // Do nothing if no recently viewed products
      if (viewedProductIdArray.length > 0) {
        var url = `${PY3_API_BASE_URL}/api/v1.1/shopify-domain/products/recently-viewed/`;
        var postData = {
          shopify_product_ids: viewedProductIdArray.join(','),
          product_count: displayCount || 20,
          format: 'json',
        };

        $.ajax({
          url,
          cache: false,
          type: 'POST',
          datatype: 'json',
          data: postData,
          success: callbackFunction,
        });
      }
    },
    addUserInterestedProductCSId: function (productCSId) {
      if (!productCSId) return false;

      const productId = String(productCSId);
      const userInterestedProductCSIds = new Set(
        localStorage.getItem('user_interested_product_cs_ids')?.split(',') ||
          [],
      );

      if (userInterestedProductCSIds.has('undefined')) {
        userInterestedProductCSIds.delete('undefined');
      }

      if (userInterestedProductCSIds.has(productId)) {
        userInterestedProductCSIds.delete(productId);
      } else if (userInterestedProductCSIds.size >= 30) {
        userInterestedProductCSIds.delete(
          userInterestedProductCSIds.keys().next().value,
        );
      }
      userInterestedProductCSIds.add(productId);
      localStorage.setItem(
        'user_interested_product_cs_ids',
        [...userInterestedProductCSIds].join(','),
      );
    },
  },
  storefrontApiManager: {
    getClient: function () {
      if (!window.shopifyStorefrontApiClient) {
        window.shopifyStorefrontApiClient = window.ShopifyStorefrontAPIClient.createStorefrontApiClient(
          {
            storeDomain: 'https://www.citiesocial.com',
            apiVersion: '2025-04', // Shopify 每年 1, 4, 7, 10 月會更新 API 版本
            publicAccessToken: '0b706795c287c63a02dabd228859d803',
          },
        );
      }
      return window.shopifyStorefrontApiClient;
    },
    mutation: {
      customerAccessTokenCreateWithMultipass: `
        mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
          customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
            customerAccessToken {
              accessToken
              expiresAt
            }
            customerUserErrors {
              code
              field
              message
            }
          }
        }
      `,
      customerAddressCreate: `
        mutation customerAddressCreate($address: MailingAddressInput!, $customerAccessToken: String!) {
          customerAddressCreate(address: $address, customerAccessToken: $customerAccessToken) {
            customerAddress {
              id
            }
            customerUserErrors {
              code
              field
              message
            }
          }
        }
      `,
      customerDefaultAddressUpdate: `
        mutation customerDefaultAddressUpdate($addressId: ID!, $customerAccessToken: String!) {
          customerDefaultAddressUpdate(addressId: $addressId, customerAccessToken: $customerAccessToken) {
            customer {
              email
            }
            customerUserErrors {
              code
              field
              message
            }
          }
        }
      `,
      cartCreate: `
        mutation ($input: CartInput) {
          cartCreate(input: $input) {
            userErrors {
              message
              code
              field
            }
            cart {
              id
              checkoutUrl
              buyerIdentity {
                deliveryAddressPreferences {
                  ...on MailingAddress {
                    address1
                    firstName
                    city
                    country
                  }
                }
              }
            }
          }
        }
      `,
    },
    query: {
      customer: `
        query CustomerQuery($customerAccessToken: String!) {
          customer(customerAccessToken: $customerAccessToken) {
            id
            email
            addresses(first: 100) {
              nodes {
                id
                address1
                address2
                city
                company
                country
                countryCode
                province
                firstName
                lastName
                phone
                zip
              }
            }
            defaultAddress {
              id
            }
          }
        }`,
    },
  },
};
